import React from 'react';
import { Success, Saved, Info } from '../img';

const MessageAction = (props) => {
  let class_message = 'message_hidden';
  let icon = null;

  if(props.show){
    class_message = 'message_purple';
    //
    switch (props.type){
      case 'success':
        icon = <Success/>;
        break;
      case 'info':
        icon = <Info/>;
        break;
      case 'saved':
        icon = <Saved/>;
        break;
      case 'error':
        icon = <Info color="#F00"/>;
        class_message = 'message_error';
        break;
      default:
        icon = null;
    }
  }

  return(
    <div className={class_message}>
      <div>
        {icon}
        {props.message}
      </div>
    </div>
  )
}

export default MessageAction;



// WEBPACK FOOTER //
// ./src/components/MessageAction.js